import { EmbedItemPadding } from '@nucleus/types/web';
import React from 'react';
import styled, { css } from 'styled-components';
import { BlockLayout, blockLayoutInnerProps } from '../../blockLayouts/Base';
import { BlockEmbedGrid } from '../../blocks/BlockEmbedGrid';
import { BlockInfo } from '../../blocks/BlockInfo';
import { SpacerTop } from '../../sectionLayouts/Spacers';
import { EmbedBlockLayoutProps } from './EmbedLayout';

export const EmbedBlockLayoutVertical = (props: EmbedBlockLayoutProps): JSX.Element => {
  const innerProps = blockLayoutInnerProps(props);

  const itemPadding = props.blocks?.[0]?.itemPadding;
  const embedsOnTheBottom = props.blockLayoutVariant === 'variant2';

  return (
    <StyledBlockLayout {...props} itemPadding={itemPadding} embedsOnTheBottom={embedsOnTheBottom}>
      <SpacerTop />
      <StyledBlockEmbedGrid {...innerProps} block={props.blocks[0]} />
      <StyledBlockInfo {...innerProps} block={props.blocks[0]} />
    </StyledBlockLayout>
  );
};

const StyledBlockInfo = styled(BlockInfo)``;
const StyledBlockEmbedGrid = styled(BlockEmbedGrid)``;

const StyledBlockLayout = styled(BlockLayout)<{
  itemPadding?: EmbedItemPadding;
  embedsOnTheBottom?: boolean;
}>`
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;

  ${StyledBlockEmbedGrid} {
    position: relative;
    padding: ${({ itemPadding }) => (itemPadding === 'none' ? undefined : `calc(var(--unit-length) * 0.5)`)};
  }

  ${StyledBlockInfo} {
    min-height: ${(props) => {
      switch (props.height) {
        case 'medium':
          return '60vh';
        case 'large':
          return '80vh';
        default:
          return undefined;
      }
    }};
  }

  ${({ embedsOnTheBottom }) => {
    if (embedsOnTheBottom) {
      return css`
        ${StyledBlockEmbedGrid} {
          order: 3;
        }
      `;
    }
  }}
`;
